import http from "@/shared/services/http";

export const listDivisionPickup = (params: any) => http.get(`v1/division-pickups`, {params});
export const createDivisionPickup = (data: any) => http.post(`v1/division-pickups`, data);
export const singleDivisionPickup = (id) => http.get(`v1/division-pickups/${id}`);
export const listBillLadingByDivisionPickupId = (id: number, params: any) => http.get(`v1/division-pickups/${id}/bill-ladings`, {params})
export const rejectedDivisionPickup = (id, data: any) => http.put(`v1/division-pickups/reject/${id}`, data);
